import { FC, useContext, useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Link } from "react-router-dom";

import ContactAndSafetyInfo from "../../components/contactAndSafetyInfo";
import { TextAlignProps } from "../../components/contactAndSafetyInfo/types";
import FooterText from "../../components/footerText";
import HubInputField from "../../components/inputType";

import useFetch from "../../hooks/useFetch";
import { ToastContext } from "../../context/toastContext";
import { forgotpasswordSchema } from "../../validation/forgotPassword";
import { APIEndpoints } from "../../types/apiTypes";
import { ToastTypes } from "../../types";
import { ForgotPasswordResponseType } from "./types";
import { LoaderContext } from "../../context/loaderContext";
import { ProductBasedLogo } from "src/assets";

const HubForgotPassword: FC = (): JSX.Element => {
  const { control, handleSubmit, reset } = useForm({
    mode: 'all',
    resolver: yupResolver(forgotpasswordSchema),
  });
  const { loading, error, data, mutate, removeErrorAndData } = useFetch<null, null, ForgotPasswordResponseType>(APIEndpoints.USER_FORGOT_PASSWORD);
  const { showToast } = useContext(ToastContext);
  const { setLoader, hideLoader } = useContext(LoaderContext);


  useEffect(() => {
    if (data || error) {
      hideLoader();
      if(data){
        const { message } = data;
        showToast([message], ToastTypes.SUCCESS);
        reset();
      }
      if (error) {  
        showToast([error], ToastTypes.ERROR);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data, error]);

  const submitForm = async (values: { email: string }) => {
    setLoader();
    if ((error && error.length > 0) || data) removeErrorAndData();

    mutate({ user: values });
  };

  return (
      <div className="login-sec mt-0 mt-sm-0 mt-md-0 mt-lg-0 mt-xl-5 d-flex flex-fill flex-column justify-content-between overflow-auto">
        <div className="container-fluid p-0">
            <div className="container container-full d-flex flex-fill flex-column">
                <div className="my-3">
                    <ContactAndSafetyInfo alignText={TextAlignProps.TEXT_END} textColor="black"/>
                </div>
                <div className="row">
                    <div className="col-12 col-md-6">
                        <h1 className="login-text text-primary">
                            My QUTENZA Connect answers questions about treatment access and support.
                        </h1>
                    </div>
                    <div className="col-12 col-md-2 d-none d-lg-block"></div>
                    <div className="col-12 col-md-4 flex-fill">
                        <h2 className="mb-3">Forgot password</h2>
                        <form onSubmit={handleSubmit(submitForm)}>
                            <label className="pb-2">Email*</label>
                            <Controller
                                name="email"
                                control={control}
                                defaultValue=""
                                render={({field, fieldState: {error}}) => (
                                    <HubInputField
                                        inputId="email"
                                        isRowBased={false}
                                        isRequired={true}
                                        field={field}
                                        error={error}
                                        inputLabel=""
                                        inputType="email"
                                    />
                                )}
                            />
                            <div className="row align-items-center">
                                <div className="col-auto">
                                    <button disabled={loading} className="btn btn-warning" type="submit">
                                        {loading ? (<i className="spinner-border me-2"></i>) : null}
                                        Send me reset password instructions
                                    </button>
                                </div>
                                <div className="col-auto">
                                    <Link to="/users/sign_in">Log in</Link>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div className="mt-3 d-flex justify-content-end">
                    <img src={ProductBasedLogo} width="220" alt="Product Logo"/>
                </div>
            </div>
            <div className="curve-bg"></div>
            <div className="bg-white"><div className="container container-full"><FooterText/></div></div>
        </div>
      </div>
  );
};

export default HubForgotPassword;
